<template>
  <div class="text-center pagination-container max-width">
    <v-pagination
      density="compact"
      v-model="page"
      :length="totalPages"
      :total-visible="visiblePages"
    ></v-pagination>
    <div class="no-display">
      {{page}}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "RAMP - Recruiting",
  props: {
    totalItemsForPages: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      required: true
    },
    visiblePages: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      page: 1,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalItemsForPages/this.perPage);
    }
  },
  watch: {
    page(currentPage) {
      this.$emit('paginationPageUpdate', currentPage);
    }
  },
});
</script>
<style>
.no-display{ display:none; }
.pagination-container{ font-size:10px; }
.v-pagination__list{ padding:5px; }
</style>